module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }